export default {
    boxLength: 320,
    boxHeight: 480,
    boxWidth: 220,
};
